import { useEffect, useRef } from 'react';
import '../css/HotlineButton.css';
import hotlineImage from '../images/Haleon/Home/whatsapp-logo.svg';

const HotLineButton = ({ noHeader, noFooter }) => {
	const threshold = 2;
	const parentRef = useRef(null);
	const eleRef = useRef(null);
	const offset = useRef({
		dx: 0,
		dy: 0,
	});
	const startPos = useRef({
		x: 0,
		y: 0,
	});
	const startPosMouse = useRef({
		x: 0,
		y: 0,
	});
	const pointerId = useRef(null);

	useEffect(() => {
		const handleResize = () => {
			if (parentRef.current && eleRef.current) {
				const parentBounds = parentRef.current.getBoundingClientRect();
				const draggableBounds = eleRef.current.getBoundingClientRect();

				if (parentBounds.width <= offset.current.dx + draggableBounds.width) {
					const diff =
						parentBounds.width - (offset.current.dx + draggableBounds.width);
					const odx = offset.current.dx + diff;
					eleRef.current.style.transform = `translate(${odx}px, ${offset.current.dy}px)`;
					offset.current = {
						dx: odx,
						dy: offset.current.dy,
					};
				} else if (parentBounds.width / 2 < offset.current.dx) {
					const diff =
						parentBounds.width - (offset.current.dx + draggableBounds.width);
					const odx = offset.current.dx + diff;
					eleRef.current.style.transform = `translate(${odx}px, ${offset.current.dy}px)`;
					offset.current = {
						dx: odx,
						dy: offset.current.dy,
					};
				}

				if (parentBounds.height <= offset.current.dy + draggableBounds.height) {
					const diff =
						parentBounds.height - (offset.current.dy + draggableBounds.height);
					const ody = offset.current.dy + diff;
					eleRef.current.style.transform = `translate(${offset.current.dx}px, ${ody}px)`;
					offset.current = {
						dx: offset.current.dx,
						dy: ody,
					};
				}
			}
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (parentRef.current && eleRef.current) {
			const ele = eleRef.current;
			const parBound = parentRef.current.getBoundingClientRect();
			const eleBound = eleRef.current.getBoundingClientRect();
			if (!offset.current.dx && !offset.current.dy) {
				const odx = Number(parBound.width - eleBound.width);
				const ody = Number(parBound.height - eleBound.height) / 2;
				ele.style.transform = `translate(${odx}px, ${ody}px)`;
				offset.current = { dx: odx, dy: ody };
			}
		}
	}, []);

	const handleVisibilityChange = () => {
		if (document.hidden) {
			const ele = eleRef.current;
			if (!ele || !pointerId.current) {
				return;
			}
			console.log('triggerremoval');
			if (ele.hasPointerCapture(pointerId.current)) {
				ele.releasePointerCapture(pointerId.current);
			}
			document.removeEventListener('pointermove', handleMouseMove);
			document.removeEventListener('pointerup', handleMouseUp);
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		}
	};

	const handleMouseMove = (e) => {
		e.preventDefault();
		const ele = eleRef.current;
		const par = parentRef.current;
		if (!ele || !par || !startPos.current) {
			return;
		}

		const parBound = par.getBoundingClientRect();
		const eleBound = ele.getBoundingClientRect();

		// Calculate new position based on mouse movement
		const dx = e.clientX - startPos.current.x;
		const dy = e.clientY - startPos.current.y;

		// Clamp the values to keep element within bounds
		const clampedDx = Math.min(
			Math.max(dx, 0),
			parBound.width - eleBound.width
		);
		const clampedDy = Math.min(
			Math.max(dy, 0),
			parBound.height - eleBound.height
		);

		ele.style.transform = `translate(${clampedDx}px, ${clampedDy}px)`;

		offset.current = { dx: clampedDx, dy: clampedDy };
	};

	const handleMouseUp = (eventMouseUp) => {
		eventMouseUp.preventDefault();
		const ele = eleRef.current;
		const par = parentRef.current;
		if (!ele || !par || !pointerId.current) {
			return;
		}

		const parBound = par.getBoundingClientRect();
		const eleBound = ele.getBoundingClientRect();

		const finalPosMouse = {
			x: eventMouseUp.clientX,
			y: eventMouseUp.clientY,
		};

		if (startPosMouse.current) {
			const wasDragged =
				Math.abs(finalPosMouse.x - startPosMouse.current.x) > threshold ||
				Math.abs(finalPosMouse.y - startPosMouse.current.y) > threshold;

			if (!wasDragged) window.open('https://wa.me/+60167015382', '_blank');

			// Snap horizontally to nearest side based on final position
			const newX =
				finalPosMouse.x >= window.innerWidth / 2
					? parBound.width - eleBound.width
					: 0;
			ele.style.transform = `translate(${newX}px, ${offset.current.dy}px)`;
			offset.current = { dx: newX, dy: offset.current.dy };
		}

		if (ele.hasPointerCapture(pointerId.current)) {
			ele.releasePointerCapture(pointerId.current);
		}
		document.removeEventListener('pointermove', handleMouseMove);
		document.removeEventListener('pointerup', handleMouseUp);
		document.removeEventListener('visibilitychange', handleVisibilityChange);
	};

	const handleMouseDown = (e) => {
		e.stopPropagation();
		e.preventDefault();
		const ele = eleRef.current;
		const par = parentRef.current;
		if (!ele || !par) {
			return;
		}

		startPos.current = {
			x: e.clientX - offset.current.dx,
			y: e.clientY - offset.current.dy,
		};

		startPosMouse.current = {
			x: e.clientX,
			y: e.clientY,
		};

		pointerId.current = e.pointerId;
		ele.setPointerCapture(e.pointerId);
		document.addEventListener('visibilitychange', handleVisibilityChange);
		document.addEventListener('pointermove', handleMouseMove);
		document.addEventListener('pointerup', handleMouseUp);
	};

	useEffect(() => {
		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
			document.removeEventListener('pointermove', handleMouseMove);
			document.removeEventListener('pointerup', handleMouseUp);
		};
	}, []);

	// Determine class name based on props
	let containerClass = 'hotline-container';
	if (!noFooter && !noHeader) {
		containerClass += ' special-class';
	} else if (noFooter && !noHeader) {
		containerClass += ' special-class-no-footer';
	} else if (!noFooter && noHeader) {
		containerClass += ' special-class-no-header';
	} else {
		containerClass += ' full-screen';
	}

	return (
		<div
			className={containerClass}
			style={{ backgroundColor: 'transparent' }}
			ref={parentRef}
		>
			<div
				className="hotline-button"
				ref={eleRef}
				onPointerDown={handleMouseDown}
			>
				<img src={hotlineImage} alt="hotlineImage" />
			</div>
		</div>
	);
};

export default HotLineButton;
